import React from 'react';
import type { ChatStep } from '../../../../types/stream.types';
import type { ToolRenderer, ToolSummary, ToolContent } from '../tool-renderer.types';
import { Search } from 'lucide-react';

export class SearchToolRenderer implements ToolRenderer {
  getSummary(step: ChatStep, isStreaming: boolean): ToolSummary {
    const metadata = step.output?.metadata;

    if (metadata?.total_items) {
      return {
        text: `${metadata.total_items} ${metadata.total_items === 1 ? 'result' : 'results'}`,
        icon: <Search size={10} className="text-gray-400" />,
      };
    }

    if (metadata?.document_ids && Array.isArray(metadata.document_ids) && metadata.document_ids.length) {
      const n = metadata.document_ids.length;
      return {
        text: `${n} ${n === 1 ? 'document' : 'documents'}`,
        icon: <Search size={10} className="text-gray-400" />,
      };
    }

    return {
      text: isStreaming ? 'Searching...' : 'Search completed',
      icon: <Search size={10} className="text-gray-400" />,
    };
  }

  getContent(step: ChatStep): ToolContent {
    const content = step.output?.content || '';
    const metadata = step.output?.metadata;

    return {
      main: (
        <div className="text-xs text-gray-500 leading-relaxed whitespace-pre-wrap">
          {content || 'No results'}
        </div>
      ),
      metadata:
        metadata && typeof metadata.total_items === 'number' ? (
          <div className="flex items-center gap-1.5 text-[10px] text-gray-400 mt-2 pt-2 border-t border-gray-100/50">
            <Search size={10} className="text-gray-300" />
            <span>
              {metadata.total_items} {metadata.total_items === 1 ? 'result found' : 'results found'}
            </span>
          </div>
        ) : undefined,
    };
  }
}
